import type { IconProps } from './types';
import './icons.css';

export default function AnonymizedFile({
  width,
  height,
  className = '',
}: IconProps): React.JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || 16}
      height={height || 17}
      viewBox="0 0 16 17"
      className={`icon icon-anonymized-file ${className || ''}`}
    >
      <path
        stroke="#808589"
        fill="transparent"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M2.667 10V3.167c0-.737.597-1.333 1.333-1.333h4.114c.354 0 .693.14.943.39l3.886 3.886c.25.25.39.589.39.942V10"
      />
      <path
        stroke="#808589"
        strokeDasharray="2 3"
        strokeLinejoin="round"
        fill="transparent"
        d="M2.667 11.174v2.66c0 .736.597 1.333 1.333 1.333h8c.736 0 1.333-.597 1.333-1.334v-2.659"
      />
      <path
        stroke="#808589"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="transparent"
        d="M8.667 2.167V6.5h4"
      />
      <path
        stroke="#808589"
        strokeLinecap="round"
        d="M1 10h14"
        fill="transparent"
      />
    </svg>
  );
}
